export default "__VITE_ASSET__BPlEJXxS__"